/** @format */
import {SyntheticEvent, useState} from 'react';

import {ArrowDropDown} from '@mui/icons-material';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Checkbox,
  IconButton,
  Typography,
} from '@mui/material';
import clsx from 'clsx';

import {YalperPlatform} from 'graphql/generated/types';

import {sensorName} from 'helpers/sensor_names';
import {useTexts} from 'helpers/sensorsTextsHelpers';

import {useCompanyContext} from 'contexts/CompanyContext';

import {Group} from '..';
import {SensorAdSystemIcons} from './SensorAdSystemIcons';
import {classes, StyledBox} from './styles';

interface SelectableListItemProps {
  id: string;
  platforms: ReadonlyArray<YalperPlatform>;
  group?: Group;
  isSelected: boolean;
  onSelect: (id: string) => void;
}

export const SelectableListItem = ({
  id,
  platforms,
  group,
  isSelected,
  onSelect,
}: SelectableListItemProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const sensorTexts = useTexts();
  const {currentAdType} = useCompanyContext();

  const label = sensorName(id);

  const handleSelect = (e: SyntheticEvent) => {
    e.stopPropagation();
    onSelect(id);
  };

  const handleExpand = (e: SyntheticEvent) => {
    e.stopPropagation();
    setIsExpanded(pre => !pre);
  };

  const wrapperClassName = clsx(
    isExpanded ? classes.selectableListItemWrapperExpanded : classes.selectableListItemWrapper,
    Boolean(group) && classes.selectableListItemAssigned,
  );

  let description = sensorTexts[id]?.short_info[currentAdType];

  // Если описание отсутствует, то берем текст из другого типа.
  // Подробнее: https://adsensor-ru.atlassian.net/browse/AS-6893
  if (!description) {
    const inverseType = currentAdType === 'CONTEXT' ? 'TARGET' : 'CONTEXT';
    description = sensorTexts[id]?.short_info[inverseType] ?? '';
  }

  return (
    <StyledBox>
      <Accordion className={wrapperClassName} expanded={isExpanded}>
        <AccordionSummary
          onClick={handleSelect}
          expandIcon={
            <IconButton
              onClick={handleExpand}
              className={classes.selectableListItemExpanderWrapper}
            >
              <ArrowDropDown className={classes.selectableListItemExpander} />
            </IconButton>
          }
        >
          {group?.icon ? (
            <Box className={classes.selectableListItemIconWrapper}>{group.icon}</Box>
          ) : (
            <Checkbox
              checked={isSelected}
              className={classes.selectableListCheckbox}
              color='default'
            />
          )}
          <SensorAdSystemIcons platforms={platforms} />
          <Typography>{label}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography className={classes.selectableListItemContent}>{description}</Typography>
        </AccordionDetails>
      </Accordion>
    </StyledBox>
  );
};
